import React, { useEffect, useState } from "react";
import classes from "../styles/BackToTopButton.module.css";

/**
 * כפתור "חזרה למעלה" צף.
 * מופיע רק אחרי שה-section hero (האלמנט עם targetId) יצא מהמסך,
 * ובלחיצה גולל את המשתמש חזרה אליו.
 */
export default function BackToTopButton({ targetId = "hero" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target) return undefined;

    // IntersectionObserver — מציג את הכפתור ברגע שה-hero לא נראה יותר
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        ([entry]) => setVisible(!entry.isIntersecting),
        { threshold: 0 }
      );
      observer.observe(target);
      return () => observer.disconnect();
    }

    // fallback לדפדפנים ישנים
    const onScroll = () => {
      const { bottom } = target.getBoundingClientRect();
      setVisible(bottom <= 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [targetId]);

  const scrollToTop = () => {
    const target = document.getElementById(targetId);
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const behavior = reduceMotion ? "auto" : "smooth";

    // גוללים לפי מיקום מחושב (ולא scrollIntoView) כדי שה-header הדביק
    // לא יכסה את תחילת ה-hero; עבור ה-hero שבראש העמוד זה מגיע ל-0
    const HEADER_OFFSET = 80;
    const top = target
      ? Math.max(0, target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET)
      : 0;
    window.scrollTo({ top, behavior });

    if (typeof window.gtag === "function") {
      window.gtag("event", "back_to_top_click", { event_category: "engagement" });
    }
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`${classes.button} ${visible ? classes.visible : ""}`}
      aria-label="חזרה למעלה"
      title="חזרה למעלה"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
}
